"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
var Tooltip_1 = __importDefault(require("@material-ui/core/Tooltip"));
var useStyles = makeStyles_1.default(function () { return ({
    root: {
        height: '100%',
        flex: function (props) { return props.count; },
        backgroundColor: function (props) { return props.color; },
    },
}); });
var FlexibleBar = function (_a) {
    var label = _a.label, count = _a.count, color = _a.color;
    var classes = useStyles({ count: count, color: color });
    return (react_1.default.createElement(Tooltip_1.default, { title: label, placement: "top", arrow: true },
        react_1.default.createElement("div", { className: classes.root })));
};
exports.default = FlexibleBar;
